import { AxiosInstance } from 'axios';

import { createAxiosInstance } from '@app/common/axios.factory';
import { environment } from '@app/environments/environment';

const SHARED_CMS_AXIOS_INSTANCE_SYMBOL = Symbol.for('nocowanie.ssr.sharedCmsAxiosInstance');

type GlobalStore = typeof globalThis & {
    [SHARED_CMS_AXIOS_INSTANCE_SYMBOL]?: AxiosInstance;
};

export const getSharedCmsAxiosInstance = (): AxiosInstance => {
    const globalStore = globalThis as GlobalStore;

    if (!globalStore[SHARED_CMS_AXIOS_INSTANCE_SYMBOL]) {
        globalStore[SHARED_CMS_AXIOS_INSTANCE_SYMBOL] = createAxiosInstance({
            baseURL: environment.CMS_API_ENDPOINT,
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    return globalStore[SHARED_CMS_AXIOS_INSTANCE_SYMBOL] as AxiosInstance;
};
